import React, { useState } from 'react';
import '../../styles/reference/reddy-reference.css'; // scoped: bootstrap 5.2.0 + swiper + common_style + theme_master + reddybook.club
import '../../styles/reddy-supplement.css';
import Header from './Header';
import SportsNav from './SportsNav';
import Sidebar from './Sidebar';
import HomeFooter from './HomeFooter';
import LoginModal from './LoginModal';
import SignupModal from '../auth/SignupModal';
import MobileBottomNav from './MobileBottomNav';

/* Shared shell (header + nav + sidebar + #main + footer + login/signup modals).
   Used by the homepage AND the match page. */
export default function ReddyLayout({ children }) {
  const [loginOpen, setLoginOpen] = useState(false);
  const [signupOpen, setSignupOpen] = useState(false);
  /* mobile off-canvas drawer: `.toggle-sidebar` on the root drives the @media
     rules (.toggle-sidebar .sidebar → left:0, .toggle-sidebar .main::before →
     backdrop, .toggle-sidebar → scroll-lock). Desktop is unaffected. */
  const [drawerOpen, setDrawerOpen] = useState(false);
  const closeDrawer = () => setDrawerOpen(false);
  return (
    <div className="reddy-home">
      {/* `.toggle-sidebar` must WRAP .sidebar + .main (the scoped selectors are
          `.reddy-home .toggle-sidebar .sidebar` etc. — the reference toggled it on
          <body>, an ancestor). This inner wrapper is that ancestor. */}
      <div className={drawerOpen ? 'toggle-sidebar' : undefined}>
        <Header onLogin={() => setLoginOpen(true)} onSignup={() => setSignupOpen(true)} onToggleDrawer={() => setDrawerOpen((o) => !o)} />
        <SportsNav />
        <Sidebar onCloseDrawer={closeDrawer} />
        {/* clicking the backdrop (the .main::before overlay) closes the drawer */}
        <main id="main" className="main" onClick={drawerOpen ? closeDrawer : undefined}>
          {children}
          <HomeFooter />
        </main>
      </div>
      {/* mobile-only bottom nav (.footer_mobilemenu — hidden >991px via scoped @media) */}
      <MobileBottomNav />
      <LoginModal open={loginOpen} onClose={() => setLoginOpen(false)} />
      <SignupModal
        open={signupOpen}
        onClose={() => setSignupOpen(false)}
        onLogin={() => { setSignupOpen(false); setLoginOpen(true); }}
      />
    </div>
  );
}
